export default {"src":"/static/spa/fresh-spa/_next/static/media/icon-arrives-cold.e57b09ec.svg","height":135,"width":141,"blurWidth":0,"blurHeight":0};